import {
  GridActionsCellItem,
  GridColDef,
  GridRowParams,
} from '@mui/x-data-grid';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, Link as RouterLink } from 'react-router-dom';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useUidColumn } from 'src/feature/data-grid/column/use-uid-column';
import { CpoResponseModel } from 'src/core/model/cpo.model';
import { useTextColumn } from 'src/feature/data-grid/column/use-text-column';
import { useDidColumn } from 'src/feature/data-grid/column/use-did-column';
import { APP_PATH } from 'src/config/app-paths';
import { PullCpoLocationsAction } from '../cpo-pull-locations/pull-cpo-locations.action';

export function useCpoColumn(): GridColDef[] {
  const { t } = useTranslation();

  const cpoTranslations: Record<keyof CpoResponseModel, string> = t(
    'model.cpo',
    {
      returnObjects: true,
    },
  );

  const uidColumn = useUidColumn();
  const textColumn = useTextColumn();
  const didColumn = useDidColumn();
  const endpointColumn = useTextColumn();

  return useMemo(
    () => [
      {
        ...uidColumn,
        field: 'id',
        headerName: cpoTranslations.id,
        width: 400,
      },
      {
        ...textColumn,
        field: 'publicKey',
        headerName: cpoTranslations.publicKey,
      },
      {
        ...didColumn,
        field: 'did',
        headerName: cpoTranslations.did,
      },
      {
        ...endpointColumn,
        field: 'endpoint',
        headerName: cpoTranslations.endpoint,
        width: 400,
      },
      {
        field: 'actions',
        type: 'actions',
        width: 60,
        getActions: (params: GridRowParams<CpoResponseModel>) => [
          <GridActionsCellItem
            key="link-to-detail"
            component={RouterLink}
            target="_blank"
            label={t('cpo.data-grid.cta.view-detail')}
            icon={<OpenInNewIcon />}
            to={generatePath(APP_PATH.CPO_DETAILS, {
              cpoId: params.row.id,
            })}
          />,
          <PullCpoLocationsAction
            key="pull-cpo-locations"
            cpoId={params.row.id}
            label={t('cpo.data-grid.cta.pull-cpo-locations')}
          />,
        ],
      },
    ],
    [t, cpoTranslations, didColumn, endpointColumn, textColumn, uidColumn],
  );
}
